export default {
    compententsApi: {
        select: '请选择审核数据',
        selectorder: '请选择待审核的订单',
        permissions: '您权限不足，无法审核选中的订单',
        passed: '是否通过审核售后单',
        review: '是否拒绝审核售后单',
        rejected: '审核拒绝',
        reason: '请输入拒绝原因',
        Please: '请输入',
    }
};
